import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "savings-card" };
const _hoisted_2 = { class: "savings-content" };
const _hoisted_3 = { class: "savings-header" };
const _hoisted_4 = { class: "savings-label" };
const _hoisted_5 = { class: "savings-amount" };
const _hoisted_6 = { class: "pagination-dots" };
import { ref, computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SavingsCard',
    props: {
        items: {},
        formatter: {}
    },
    setup(__props) {
        const props = __props;
        const currentDot = ref(0);
        const totalDots = computed(() => props.items.length);
        function getCurrentLabel() {
            return props.items[currentDot.value]?.label || '';
        }
        return (_ctx, _cache) => {
            const _component_v_carousel_item = _resolveComponent("v-carousel-item");
            const _component_v_carousel = _resolveComponent("v-carousel");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(getCurrentLabel()), 1)
                    ]),
                    _createVNode(_component_v_carousel, {
                        modelValue: currentDot.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentDot).value = $event)),
                        "show-arrows": false,
                        "show-arrows-on-hover": false,
                        "hide-delimiter-background": "",
                        "delimiter-icon": "mdi-circle",
                        height: "auto",
                        class: "savings-carousel"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                                return (_openBlock(), _createBlock(_component_v_carousel_item, { key: index }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatter.format(item.value)), 1)
                                    ]),
                                    _: 2
                                }, 1024));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalDots.value, (dot, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: _normalizeClass(['dot', { active: index === currentDot.value }])
                        }, null, 2));
                    }), 128))
                ])
            ]));
        };
    }
});
